import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    goalAmount: null,
    amountRaised: 0,
    supportersCount: 0,
    currency: 'USD',
    deadline: null,
    updates: [],
    topSupporters: [],
    presetAmounts: [],
    coverImage: '',
    coverCredit: '',
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const crowdfundingSlice = createSlice({
  name: 'crowdfunding',
  initialState,
  reducers: {
    crowdfundingStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        goalAmount: blockContent?.goalAmount ?? null,
        amountRaised: blockContent?.amountRaised ?? 0,
        supportersCount: blockContent?.supportersCount ?? 0,
        currency: blockContent?.currency ?? 'USD',
        deadline: blockContent?.deadline ?? null,
        updates: blockContent?.updates ?? [],
        topSupporters: blockContent?.topSupporters ?? [],
        presetAmounts: blockContent?.presetAmounts ?? [],
        coverImage: blockContent?.coverImage ?? '',
        coverCredit: blockContent?.coverCredit ?? '',
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    crowdfundingClear: () => initialState,

    crowdfundingUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    crowdfundingUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    crowdfundingUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { crowdfundingStore, crowdfundingClear, crowdfundingUpdateIsLoading, crowdfundingUpdateIsActive, crowdfundingUpdateBlockContent } = crowdfundingSlice.actions;

export const selectCrowdfundingIsLoading = (state) => state.crowdfunding.isLoading;
export const selectCrowdfundingId = (state) => state.crowdfunding.id;
export const selectCrowdfundingUID = (state) => state.crowdfunding.uid;
export const selectCrowdfundingSID = (state) => state.crowdfunding.sid;
export const selectCrowdfundingBlockContent = (state) => state.crowdfunding.blockContent;
export const selectCrowdfundingItemDesign = (state) => state.crowdfunding.itemDesign;
export const selectCrowdfundingContainerDesign = (state) => state.crowdfunding.containerDesign;

export default crowdfundingSlice.reducer;
